import React, { useState, useEffect } from 'react';
import { lockWindow } from '../../utils/methods';
import './index.scss';

const ModalBox = ({ className, open=true, onClose, children }) => {
  const [ modalOpen, setModalOpen ] = useState(false);

  useEffect(() => {
    lockWindow(open);
    setModalOpen(open);
  }, [open]);

  const handleCloseModal = () => {
    setModalOpen(false);
  }

  return (
    <div className={`modal-box ${className ? className : ''} ${ modalOpen ? 'open' : '' }`}>
      <div className="mask" onClick={ () => {
        onClose();
        handleCloseModal();
      } }></div>
      <div className="box">
        { children }
        <button className="close text-button" onClick={() => {
          onClose();
          handleCloseModal();
        } }>CLOSE</button>
      </div>
    </div>
  )
}

export default ModalBox;
